import React, { useState } from "react";
import Modal from "../base/Modal";

const TitleDescriptionModal = ({
  initialTitle,
  initialDescription,
  onClose,
  onSave, viewOnly
}) => {
  const [title, setTitle] = useState(initialTitle);
  const [description, setDescription] = useState(initialDescription);

  const handleSave = () => {
    onSave(title, description);
  };

  return (
    <Modal title={viewOnly ? "View Workflow": "Edit Workflow"} isOpen={true} onClose={onClose}>
      <div className="flex flex-col gap-4 p-4 bg-zinc-900">
        <div className="space-y-2">
          <label
            htmlFor="title"
            className="block text-sm font-medium text-zinc-300"
          >
            Workflow Title
          </label>
          <input
            id="title"
            type="text"
            value={title}
            disabled={viewOnly}
            onChange={(e) => setTitle(e.target.value)}
            placeholder="Enter workflow title"
            className="w-full px-3 py-2 bg-zinc-800 border border-zinc-700 text-zinc-100 rounded-md
                     placeholder-zinc-500 focus:outline-none focus:ring-2 focus:ring-[#5652CF] focus:border-transparent
                     transition duration-200"
          />
        </div>

        <div className="space-y-2">
          <label
            htmlFor="description"
            className="block text-sm font-medium text-zinc-300"
          >
            Workflow Description
          </label>
          <textarea
            id="description"
            value={description}
            disabled={viewOnly}
            onChange={(e) => setDescription(e.target.value)}
            placeholder="Enter workflow description"
            rows={4}
            className="w-full px-3 py-2 bg-zinc-800 border border-zinc-700 text-zinc-100 rounded-md
                     placeholder-zinc-500 focus:outline-none focus:ring-2 focus:ring-[#5652CF] focus:border-transparent
                     transition duration-200 resize-none"
          />
        </div>
        {!viewOnly &&
        (<div className="flex justify-end gap-3 mt-2">
          <button
            onClick={handleSave}
            className="px-4 py-2 text-zinc-300 bg-zinc-800 hover:bg-zinc-700 
                     border border-zinc-700 rounded-md transition duration-200
                     focus:outline-none focus:ring-2 focus:ring-zinc-500"
          >
            Save Changes
          </button>
        </div>)
        }
      </div>
    </Modal>
  );
};

export default TitleDescriptionModal;
